<!-- 表单中物料设备等树组件筛选部分 循环 -->
<template>
  <div
    v-if="child && child.length"
    class="child"
  >
    <div
      v-for="(item, i) in child"
      :key="i"
      :k="item.id"
      class="check-one clearfix"
      :class="{
        'checked': item.checked,
        'last-child': !item.child || !item.child.length
      }"
      @click.stop="onClickCheck(item, i, $event)"
    >
      <i class="line border-bottom-1px" />

      <span
        class="name-wrap"
        :class="{ disabled: item.disabled }"
      >
        <i class="iconfont icon-success iconicon-test19" />
        <i class="uncheck-item" />
        <em class="name">{{ item.name }}</em>
        <i
          class="iconfont"
          :class="{
            'icon-angle-right iconicon-test18': (!item.show && item.child && item.child.length),
            'icon-angle-down iconicon-test17': (item.show && item.child && item.child.length)
          }"
        />
      </span>

      <class-child
        v-if="item.child && item.child.length"
        v-show="item.show"
        :child="item.child"
        @change="handleChange"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ClassChild',
  props: {
    'child': {
      type: [Array, Object, Number, String],
      default: () => { }
    }
  },
  data () {
    return {}
  },

  methods: {
    /* setShow (child) {
      for (let k in child) {
        if (child[k].child) {
          this.setShow(child[k].child)
        }
      }
    }, */
    onClickCheck (item, i, ev) {
      if (ev.target.className.indexOf('name') !== -1 || ev.target.className.indexOf('iconfont icon-success') !== -1 || ev.target.className.indexOf('uncheck-item') !== -1) { // 点击选择
        if (item.disabled) {
          return
        }
        if (!item.checked) {
          this.$set(item, 'checked', true)
        } else {
          this.$set(item, 'checked', false)
        }
        this.$emit('change', item)
      } else if (ev.target.className.indexOf('check-one') !== -1 || ev.target.className.indexOf('iconfont icon-angle-right') !== -1 || ev.target.className.indexOf('iconfont icon-angle-down') !== -1) { // 点击展开
        if (!item.show) {
          this.$set(item, 'show', true)
        } else {
          this.$set(item, 'show', false)
          // this.setShow(item.child)
        }
      }
    },
    handleChange (item) {
      this.$emit('change', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.check-one {
  display: block;
  min-height: 48px;
  line-height: 24px;
  text-align: left;
  font-size: 16px;
  &:first-child .line {
    background: none;
  }
  .check-one {
    margin-left: 10px;
  }
  .line {
    position: absolute;
    left: 12px;
    display: block;
    width: 100%;
  }
  .name-wrap {
    display: flex;
    padding: 12px 0;
    &.disabled {
      color: #ccc;
    }
    .name {
      flex: 1;
      display: inline-block;
      font-style: normal;
    }
  }
  .iconfont {
    color: #dbdbdb;
  }
  .icon-angle-right,
  .icon-angle-down {
    float: right;
    margin-right: 12px;
    font-size: 16px;
    font-weight: bold;
  }
  .icon-success {
    display: none;
    &:before {
      padding: 10px;
    }
  }
  .uncheck-item {
    width: 14px;
    height: 14px;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    display: inline-block;
    margin: 5px 10px 0;
  }
  &.checked > .name-wrap > .icon-success {
    color: #5077aa;
    display: inline-block;
  }
  &.checked > .name-wrap > .uncheck-item {
    display: none;
  }
}
</style>
